<template>
  <div class="default-input">
    <div class="default-input__input">
      <input v-model="value" type="text" @focus="showTooltip = true" @blur="hideTooltip" placeholder="Введите адрес">
    </div>
    <div class="default-input__clear" v-if="value" @click="$emit('update:modelValue', '')"></div>
    <div class="default-input__search" v-else></div>
    <div class="default-input__tooltip" :class="{active: showTooltip}">
      <div class="default-input__tooltip-item" v-if="!tooltipsData.length && value" style="pointer-events: none">К сожалению по такому адресу не найден ломбард, обратитесь к нашей карте</div>
      <div class="default-input__tooltip-item" v-else-if="!tooltipsData.length" style="pointer-events: none">Начните ввод</div>
      <template v-for="(tooltip, index) in tooltipsData" :key="index">
        <slot name="tooltip" :tooltip="tooltip">
          <div class="default-input__tooltip-item" @click="value = tooltip[tooltipValueProp], hideTooltip">
            {{ tooltip[tooltipLabelProp] }}
          </div>
        </slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddressSearch",
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    tooltipsData: {
      type: Array,
      default: () => []
    },
    tooltipLabelProp: {
      type: String,
      default: 'name'
    },
    tooltipValueProp: {
      type: String,
      default: 'value'
    }
  },
  data() {
    return {
      timeout: null,
      showTooltip: false
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('update:modelValue', value)
        }, 500)
      }
    }
  },
  methods: {
    hideTooltip() {
      if (this.showTooltip) {
        setTimeout(() => {
          this.showTooltip = false
        }, 300)
      }
    }
  }
}
</script>

<style scoped>

</style>